var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShippingBox = function SvgShippingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#shipping-box_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .571v4.572M9.714 12.571h2.858M.572 5.143h14.857v9.142a1.143 1.143 0 0 1-1.143 1.143H1.714a1.143 1.143 0 0 1-1.142-1.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.572 5.143 2.286 1.84A2.29 2.29 0 0 1 4.274.57h7.452A2.29 2.29 0 0 1 13.77 1.84l1.658 3.303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shipping-box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgShippingBox;